import { Injectable } from '@angular/core';
import { OfflineService } from './offline.service';
import { Params } from '@angular/router';
import { EMPTY, map, Observable, of } from 'rxjs';
import { IPaginatedResponse } from '../../typing/response.interface';
import { ILabelValue } from '../common-dropdawn/typing/label-value.interface';
import { IPrice } from '../../typing/price.interface';

@Injectable({
    providedIn: 'root'
})
export class OfflinePriceService {
    constructor(private offlineService: OfflineService) {}

    getList(query: Params): Observable<IPaginatedResponse<ILabelValue>> {
        if (!this.offlineService.prices$.value) {
            return EMPTY;
        }

        const data = of(this.offlineService.prices$.value);
        return data.pipe(map(response =>  {
            if (query['search'].length) {
                const filerData = this.transformData(response).data.filter((item) =>  {
                    return item.label.toLowerCase().includes(query['search'].toLowerCase());
                });

                return {
                    ...response,
                    data: filerData,
                };
            }

            return this.transformData(response);
        }));
    }

    transformData(paginatedResponse: IPaginatedResponse<IPrice>): IPaginatedResponse<ILabelValue> {
        const transformedData = paginatedResponse.data.map(price => ({
            label: `${price.work.name} ${price.category?.name ?? ''}`,
            value: price.id,
            tooltip: this.getTooltip(price),
        }));

        return {
            ...paginatedResponse,
            data: transformedData,
        } as IPaginatedResponse<ILabelValue>;
    }

    getOptionsByValue(optionValue: number | string): Observable<ILabelValue> {
        const equipment =  this.offlineService.prices$.value?.data.map((price) => {
            return {
                label: `${price.work.name} ${price.category.name}` as string,
                value: price.id as number,
                tooltip: '---',
            };
        }).find((item) => item.value === Number(optionValue));

        if (!equipment) {
            return  EMPTY;
        }

        return of(equipment);
    }

    getTooltip(value: IPrice): string {
        return (value.id ? value.id : '') + (value.id ? '; id:' + value.id : '') ;
    }
}
